import { h } from '../utils/dom.js';

const getInitials = (name) =>
  name ? name.split(/\s+/).slice(0, 2).map((w) => w[0]).join('').toUpperCase() : '?';

export const Avatar = (name, color, size = 36) => {
  return h('div', {
    class: 'avatar',
    style: `--avatar-bg: ${color || 'var(--c-accent)'}; --avatar-size: ${size}px; --avatar-font: ${Math.round(size * 0.38)}px;`
  }, getInitials(name));
};

export const AVATAR_COLORS = [
  '#ed5565',
  '#a78bfa',
  '#5e9beb',
  '#ffce54',
  '#4fc1e9',
  '#ac92ec',
  '#c4b5fd',
  '#fb6e51',
  '#ec87c0',
];

export const DEFAULT_AVATAR_COLOR = '#5e9beb';
